import { render } from "./ChooseTaskAssessmentModal.vue?vue&type=template&id=ed6e3290&scoped=true"
import script from "./ChooseTaskAssessmentModal.vue?vue&type=script&lang=js"
export * from "./ChooseTaskAssessmentModal.vue?vue&type=script&lang=js"

import "./ChooseTaskAssessmentModal.vue?vue&type=style&index=0&id=ed6e3290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed6e3290"]])

export default __exports__